import { getItemFromCollection } from "directus/src/operations";

export async function fetchBillable({ billableId, includeAmount = true }) {
  try {
    const baseFields = [
      "id",
      "name",
      "status",
      "type",
      "billing_date",
      "invoice_date",
      "forecast_date",
      "collected_date",
      "due_date",
      "job.id",
      "job.name",
      "job.type",
      "job.project.id",
      "job.project.name",
      "job.project.project_id",
      "extensions.date_created",
      "extensions.start_date",
      "extensions.billing_date",
      "attributed_to.id",
      "date_created",
      "date_updated",
    ];

    const amountFields = [
      "amount", 
      "currency.name", 
      "adjusted_amount",
      "fixed_billing_config.approved_hours_threshold",
      "hourly_billing_config.billable_hours",
      "dedicated_billing_config.working_days",
      "dedicated_billing_config.billable_days",
    ];

    const fields = includeAmount
      ? [...baseFields, ...amountFields]
      : baseFields;

    const query = {
      fields,
      deep: {
        extensions: {
          _sort: ["date_created"],
        },
      },
    };

    const data = await getItemFromCollection("billables", billableId, query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
